<script setup lang="ts">
import { ref, watch } from 'vue'
import { routerPush } from '@/router'

import HelpContent from '@/components/content/HelpContent.vue'
import ParticipantSelectActive from '@/components/participant/ParticipantSelectActive.vue'

import { useCartStore } from '@/stores/cart'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { accountLogout } from '@/helpers/account-helpers'

/** Cart Store **/
const cartStore = useCartStore()
const cartCount = ref<number>(0)

/** User / Participant / Account Store **/
const userStore = useUserStore()
const currentUser = storeToRefs(userStore)
const isLoggedIn = ref(currentUser.isLoggedin)

const showHelp = ref(false)

function toggleShowHelpDialog() {
  showHelp.value = true
}

watch(cartStore, () => {
  cartCount.value = cartStore.getItemCount()
})

// const dependantVisibility = ref(false)
// function updateDependantVisibility(value: boolean) {
//   dependantVisibility.value = value // Update the visibility based on the emitted value
// }
const accountVisibility = ref(false)
function updateAccountVisibility(value: boolean) {
  accountVisibility.value = value // Update the visibility based on the emitted value
}

function navigateToLogin() {
  // routerPush('login')
  window.location.hash = '#login'
}
async function logoutApplicationReset() {
  await accountLogout()
  // userStore.logout()
  // routerPush('home')
}
</script>
<template>
  <v-btn icon="mdi-help-circle" @click="toggleShowHelpDialog" class="text-darkblue"> </v-btn>
  <v-btn v-if="!isLoggedIn" icon="mdi-account" @click="navigateToLogin"> </v-btn>

  <template v-if="isLoggedIn">
    <v-btn
      icon="mdi-tournament"
      @click="routerPush('tournaments')"
      v-tooltip="'Register for a Tournament'"
    >
    </v-btn>

    <v-btn
      v-if="cartCount ?? false"
      @click="routerPush('cart')"
      v-tooltip="'View Cart and Checkout'"
    >
      <v-badge :content="cartCount">
        <v-icon icon="mdi-cart" size="x-large" class="text-darkblue" />
      </v-badge>
    </v-btn>

    <!--    <v-btn-->
    <!--      icon="mdi-account-group"-->
    <!--      id="menu-account-group"-->
    <!--      v-tooltip="'Select Participant'"-->
    <!--    ></v-btn>-->
    <!--    <v-menu-->
    <!--      v-model="dependantVisibility"-->
    <!--      activator="#menu-account-group"-->
    <!--      transition="slide-y-transition"-->
    <!--      location="bottom"-->
    <!--      origin="top"-->
    <!--      :close-on-content-click="false"-->
    <!--    >-->
    <!--      <ParticipantSelectActive @toggle-dropdown="updateDependantVisibility" />-->
    <!--    </v-menu>-->

    <v-btn icon="mdi-account" id="menu-account" v-tooltip="'Account Information'"></v-btn>
    <v-menu
      v-model="accountVisibility"
      activator="#menu-account"
      transition="slide-y-transition"
      location="bottom"
      origin="top"
      :close-on-content-click="false"
    >
      <!--      <WhoAmi @toggle-dropdown="updateAccountVisibility" />-->

      <ParticipantSelectActive @toggle-dropdown="updateAccountVisibility" />
    </v-menu>

    <v-btn
      icon="mdi-logout"
      @click="logoutApplicationReset"
      class="text-darkblue"
      v-tooltip="'Log Out'"
    ></v-btn>
  </template>

  <HelpContent v-model:modalValue="showHelp" />
</template>
